export default {
  props: {
    pos: String,
    type: String,
    name: String,
    icon: String,
  },
};
